var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-box__footer"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.goToSection(10)}}},[_vm._v("About us")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.goToSection(12)}}},[_vm._v("Send brief")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd249ab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/small-components/MainSectionFooter.vue
// module id = null
// module chunks = 